import { useQueryClient } from "@tanstack/react-query";
import { useMachine } from "../queries/machine/use-machine";
import { taskKeys } from "../queries/tasks/task-keys";
import { signal } from "./message";
import { useSignal } from "./use-signal";

const engravingCompletedSignalFilter = (machineId?: string | null) =>
  `WorkcenterNId eq '${machineId}'`;

function engravingCompletedSignal(machineId?: string | null) {
  return signal<{ d: [EngravingCompletedSignal] }>({
    enabled: !!machineId,
    app: "AppU4DM",
    channel: "APPMain_GF_EngravingCompleted",
    filters: engravingCompletedSignalFilter(machineId),
  });
}

type EngravingCompletedSignal = { ProductId: string };

export function useEngravingCompletedSignal() {
  const { machine } = useMachine();
  const queryClient = useQueryClient();

  return useSignal(
    engravingCompletedSignal(machine?.EquipmentNId),
    ({ d: [message] }) => {
      const key = taskKeys.getProductsWaitingForValidation(
        machine?.EquipmentNId,
        message.ProductId
      );

      return queryClient.invalidateQueries({ queryKey: key });
    }
  );
}
